import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageFacade } from 'ish-core/facades/message.facade';

@Component({
  selector: 'ish-success-message',
  templateUrl: './success-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SuccessMessageComponent implements OnChanges {
  private messageFacade = inject(MessageFacade);

  /**  key or message is accepted */
  readonly message = input.required<string>();
  readonly toast = input(true);

  ngOnChanges() {
    if (this.toast()) {
      this.displayToast();
    }
  }

  private displayToast() {
    const message = this.message();
    if (message) {
      this.messageFacade.success({
        message,
      });
    }
  }
}
